import { createEventBus } from "@shared/features/eventBus/createEventBus";
import { Invitation } from "@platform/types/platform.types";

export type AuthEvents = {
  "auth:signup:intent": {
    invitation?: Invitation;
  };
  "auth:signup:started": {
    invitation?: Invitation;
  };
  "auth:signup:completed": { invitation: Invitation };
  "auth:login:intent": void;
};

export const authEventBus = createEventBus<AuthEvents>();
